// src/api/index.js
export * from "./apiConfig";

// ✅ Businesses
export * as approveApi from "./business/approveApi";
export * as manageApi from "./business/manageApi";

// ✅ Blacklist
export * as blacklistApi from "./blacklist/blacklistApi";

// ✅ Job Holders (Employees)
export * as jobHolderApi from "./jobHolder/jobHolderApi";

// ✅ Accounting
export * as accountingApi from "./accounting/accountingApi";

// ✅ Settings
export * as settingsApi from "./settings/settingsApi";
